import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { Store } from '@ngrx/store';
import {
  registerIcons,
  SpinnerDirective,
  SpinnerService,
  RootActions,
  PU_ICONS,
} from '@hglobal/common';
import { ALL_ICONS } from 'libs/core/src/lib/icons/generated/icons';

@Component({
  selector: 'aa-root',
  template: `
    <ng-container *puSpinner="spinnerService.isSpinning$ | async">
      <router-outlet/>
    </ng-container>
  `,
  imports: [RouterOutlet, AsyncPipe, SpinnerDirective],
})
export class AppComponent implements OnInit {
  readonly spinnerService = inject(SpinnerService);

  readonly #store = inject(Store);

  @HostBinding('class.aa-root') isRoot = true;

  constructor() {
    registerIcons([...ALL_ICONS, ...PU_ICONS]);
  }

  ngOnInit() {
    this.#store.dispatch(RootActions.appInitialized());
  }
}
